<!--Ez az Admin login-->
<template class="my-auto">
  <div class="text-center center py-auto d-flex">
    <v-card outlined elevation="2" class="ma-auto login-card">
      <img src="@/assets/sze_logo.png" class="logo mb-1" />
      <p class="text-uppercase mb-0">{{ $store.state.lang.tanulmanyi_tajekoztato }}</p>
      <p class="text-uppercase mb-0">{{ $store.state.lang.admin_felulet }}</p>
      <v-divider class="mx-2 uni_blue2 size"></v-divider>
      <form>
        <v-text-field :label="$store.state.lang.login_felhasznalonev" class="mx-3" color="uni_blue2"
          :error-messages="errors.userName" v-model="user.userName" v-on:keyup.enter="Login" />
        <v-text-field :label="$store.state.lang.login_jelszo" class="mx-3" color="uni_blue2"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
          @click:append="show = !show" :error-messages="errors.password" v-model="user.password"
          v-on:keyup.enter="Login" />
        <v-btn dark class="ma-3" color="uni_blue" @submit="Login" @click="Login">{{
          $store.state.lang.bejelentkezes
        }}</v-btn>
      </form>
      <!-- bg-uniblue -->
      <div class="d-flex flex-row justify-end ">
        <LangSelector :dark="false" />
      </div>
    </v-card>
  </div>
</template>

<script>
import LangSelector from "@/components/LangSelector.vue";
export default {

  components: {
    LangSelector,
  },

  data: () => ({
    show: false,
    user: {
      userName: "",
      password: "",
    },
    errors: {
      userName: "",
      password: "",
    },
    alert: false,
  }),

  methods: {
    async Login() {
      this.errors = {
        userName: "",
        password: "",
      };
      try {
        const response = await this.$http.post("/login", this.user);
        if (Object.keys(response.errors).length > 0) {
          this.errors = response.errors;
        } else {
          if (response.user === false) {
            const alert = {
              show: true,
              type: "error",
              message: this.$store.state.lang.nem_megfelelo_hitelesitesi_adat
            };
            this.$store.dispatch("showAlert", alert);
            return;
          } else {
            this.$cookies.set("adminToken", response.user.token, 0);
            this.$store.commit("setUser", response.user);
            this.$router.push("/admin");
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style>
.login-card {
  width: 500px;
  max-width: 90%;
}

.center {
  min-height: 100%;
}

.margin {
  margin: auto;
}

.size {
  font-size: 30px;
}

.bg-uniblue {
  background-color: #0c3c60;
  border-radius: 0px 0px 10px 10px;
}

.logo {
  width: 300px;
  /* height: 100px; */
}
</style>